import styled from "styled-components";

export const Body = styled.div`
  padding: 0 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Question = styled.p`
  margin: 0;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
`;
